import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const getAgentList = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/agent`,
    method: "GET",
  });
};
export const getEngineerInfo = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/info/` + params,
    method: "GET",
  });
};
//查询提货单列表
export const findEliveryOrder = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order?` + params,
    method: "GET",
  });
};
//修改提货单
export const updateEliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data: data,
  });
};
//删除提货单
export const delEliveryOrder = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/${ids}`,
    method: "DELETE",
  });
};
export const getEliveryOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/info?id=` + params,
    method: "GET",
  });
};
// /joins-sales-cloud/v1/delivery_order/infoV4
export const getEliveryOrderV4 = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/infoV4?id=` + params,
    method: "GET",
  });
};
// 查询费用打印次数，查询/选否传0，选是传1，每次返回的打印次数
export const getPrintCount = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/printCount?id=${params.orderId}&count=${params.count}`,
    method: "GET",
  });
};
//查询验收单/joins-sales-cloud/v1/engineering_order/
export const findEngineeringOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order?id=` + params,
    method: "GET",
  });
};

export const findServiceRecordListOther = (data) => {
  return request({
    url:
      `${baseUrl}/joins-work/v1/workOrder/findServiceRecordListOther/` +
      data.id +
      `?clientType=` +
      data.clientType,
    method: "GET",
  });
};
export const downloadExcelEliveryOrder = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/delivery_order/downloadExcelDeliveryOrder?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
//新增提货单
export const addEliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
